export const ADD_MORE_EVENTS = "MUSICS/ADD_MORE_EVENTS";

export const EMPTY_ADD_MORE_EVENTS = "MUSICS/EMPTY_ADD_MORE_EVENTS";

export const CHANGE_LAYOUT_MODE = "MUSICS/CHANGE_LAYOUT_MODE";

export const CHANGE_PAGENUM = "MUSICS/CHANGE_PAGENUM";

export const CHANGE_SORT_MODE = "MUSICS/CHANGE_SORT_MODE";

export const CHANGE_CATEGORIES = "MUSICS/CHANGE_CATEGORIES";

// 修改时间段
export const CHANGE_TEMPORAL_INTERVAL = "MUSICS/CHANGE_TEMPORAL_INTERVAL";
